import React from 'react';
import { Input } from '@thd-olt-component-react/input';
import { Button } from '@thd-olt-component-react/core-ui';
import { string } from 'prop-types';
import styles from './share-list-url.module.scss';

export const ShareListUrL = ({ listId }) => {
  // TODO: need to update this URL when shared list page is migrated to nucleus
  const url = typeof window !== 'undefined'
    && `https://${window.location.hostname}/list/view/details/shared/${listId}`;

  const copyURL = (event) => {
    event.preventDefault();
    navigator.clipboard.writeText(url);
  };

  return (
    <div className={styles['share-list-url__container']}>
      <div data-testid="share-list-url-text-box" className={styles['share-list-url__text-box']}>
        <Input onChange={() => {}} value={url} />
      </div>
      <div className={styles['share-list-url__copy-button']}>
        <Button data-testid="share-list-url-copy-button" onClick={copyURL} outline>
          Copy
        </Button>
      </div>
    </div>
  );
};

ShareListUrL.propTypes = {
  listId: string.isRequired
};

ShareListUrL.defaultProps = {};
